import { createWheelHandler } from '@/utils/scrollPreventionService'

export default {
  inserted(el, binding) {
    // Create the wheel handler using the centralized service
    const wheelHandler = createWheelHandler(el, binding.value)

    // Store the handler for cleanup
    el.__wheelHandler__ = wheelHandler

    // Add the event listener in capture phase so it runs early, and passive: false so to preventDefault if needed
    el.addEventListener('wheel', wheelHandler, { capture: true, passive: false })
  },

  unbind(el) {
    if (el.__wheelHandler__) {
      el.removeEventListener('wheel', el.__wheelHandler__, { capture: true })
      delete el.__wheelHandler__
    }
  },
}
